import { sendWebVitals } from '@api/Metrics';
import { CLSMetric, FCPMetric, INPMetric, LCPMetric, onCLS, onFCP, onINP, onLCP, onTTFB, TTFBMetric } from 'web-vitals';

const initWebVitals = () => {
    onCLS((metric: CLSMetric) => {
        sendWebVitals(metric.name, metric.value, metric.rating)
    })

    onFCP((metric: FCPMetric) => {
        sendWebVitals(metric.name, metric.value, metric.rating)
    })

    onINP((metric: INPMetric) => {
        sendWebVitals(metric.name, metric.value, metric.rating)
    })

    onLCP((metric: LCPMetric) => {
        sendWebVitals(metric.name, metric.value, metric.rating)
    })

    onTTFB((metric: TTFBMetric) => {
        sendWebVitals(metric.name, metric.value, metric.rating)
    })
}

export default initWebVitals
